require('./hirePackOpenYoungError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    PROC_CONTRACTS,
    PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION,
    recordPath,
} = require('utilities/tagging');
const { catalogue, analyticsId } = require('../analytics/hirePackOpenYoungAnalytics');

class hirePackOpenYoungError extends React.Component {

    componentDidMount() {
        recordPath('adjuntar documentacion', '', PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION, 'error', 'tarjeta prepago open young');
    }

    buildTexts() {
        const { immHirePackOpenYoung } = this.props;
        const hireCardFail = immHirePackOpenYoung.get('hireCardError');
        let titleKey = 'hirePackOpenYoung-hirePackOpenYoung_errorTitleGeneric';
        let subtitle1 = 'hirePackOpenYoung-hirePackOpenYoung_errorSubtitleGeneric1';
        let subtitle2 = 'hirePackOpenYoung-hirePackOpenYoung_errorSubtitleGeneric2';

        if (hireCardFail) {
            titleKey = 'hirePackOpenYoung-hirePackOpenYoung_errorTitleAccount';
            subtitle1 = 'hirePackOpenYoung-hirePackOpenYoung_errorSubtitleAccount1';
            subtitle2 = 'hirePackOpenYoung-hirePackOpenYoung_errorSubtitleAccount2';
        }

        const textElement = (
            <div className="row hire-pack-open-young-error__text">
                <p className="col-xs-12 hire-pack-open-young-error__text--margin-bottom">
                    <FormattedText
                        value={subtitle1}
                    />
                    &nbsp;
                    <FormattedText
                        value={subtitle2}
                    />
                </p>
                <span className="col-xs-12 hire-pack-open-young-error__phone">
                    <i className="hire-pack-open-young-error__phone-icon icon icon-s-llamar" />
                    <FormattedText value="hirePackOpenYoung-phoneNumberClients" />
                </span>
            </div>
        );

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail } = this.props;
        const {
            textElement,
            titleKey
        } = this.buildTexts();

        const goBackButton = {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hirePackOpenYoung-hirePackOpenYoung_errorBackButtonText"
                />
            ),
            url: '/myprofile/cards'
        };

        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                processType={PROC_CONTRACTS}
                tealium={catalogue[analyticsId.OPEN_YOUNG_PACK_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-pack-open-young-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

hirePackOpenYoungError.propTypes = {
    immHirePackOpenYoung: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = hirePackOpenYoungError;
